<template>
  <div class="page-eddid-bank-account  card-shadow--small">
    <el-card>
      <div class="wrap-div">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="FPS-code" v-show="accountInfo.FPSName">
                <img :src="accountInfo.icon" alt="FPS" width="80" height="60">
                <span>{{$t('bankInfo.'+accountInfo.FPSName)}} <br>{{$t('bankInfo.'+accountInfo[acckey])}}</span>
              </div>
              <div v-show="!accountInfo.FPSName" class="fx column">
                <div class="fx m-20p">
                  <img :src="accountInfo.icon" alt="bank-logo" class="bank-logo m-bank-logo">
                  <div class="bank-name m-bank-name">
                    <!-- {{accountInfo.type=='sub'?accountInfo.bankName:$t('bankInfo.'+accountInfo.bankName)}} -->
                    {{accountInfo.type=='sub'?accountInfo.bankName:getKey(accountInfo.bankName)}}
                  </div>
                </div>
                <div class="fx">
                  <div class="bank-sub-title">
                    {{accountInfo.type=='sub'?$t('bankInfo.bankNum'):$t('bankInfo.payeeNum')}}：
                  </div>
                  <div class="bank-number">{{accountInfo.type=='sub'?accountInfo.bankSubBAccountNumber:$t('bankInfo.'+accountInfo[acckey])}}</div>
                </div>
              </div>
            </template>
            <div v-show="!accountInfo.FPSName">
              <div class="detail-info" v-if="accountInfo.type=='sub'">
                <div class="info-row">
                  <span class="row-left m-row-left">{{$t('bankInfo.payee')}}</span>
                  <span class="row-right">{{accountInfo.payeeName ? accountInfo.payeeName : ''}}</span>
                </div>
                <div class="info-row">
                  <span class="row-left m-row-left">{{$t('bankInfo.SwiftTitle')}}</span>
                  <span class="row-right">{{accountInfo.bankSwiftCode ? accountInfo.bankSwiftCode : ''}}</span>
                </div>
                <div class="info-row">
                  <span class="row-left">{{$t('bankInfo.BankAddressTitle')}}</span>
                  <span class="row-right">{{accountInfo.bankAddress ? accountInfo.bankAddress : ''}}</span>
                </div>
              </div>
              <div class="detail-info" v-else>
                <div class="info-row">
                  <!-- <span class="row-left">{{accountInfo.accountNameTitle ? $t('bankInfo.'+accountInfo.accountNameTitle) : 'null'}}</span> -->
                  <span class="row-left">{{getKey(accountInfo.accountNameTitle)}}</span>
                  <!-- <span class="row-right">{{accountInfo.accountName ? $t('bankInfo.'+accountInfo.accountName) : 'null'}}</span> -->
                  <span class="row-right">{{getKey(accountInfo.accountName)}}</span>
                </div>
                <div class="info-row">
                  <!-- <span class="row-left">{{accountInfo.swiftTitle ? $t('bankInfo.'+accountInfo.swiftTitle) : 'null'}}</span> -->
                  <span class="row-left">{{getKey(accountInfo.swiftTitle)}}</span>
                  <!-- <span class="row-right">{{accountInfo.swift ? $t('bankInfo.'+accountInfo.swift) : 'null'}}</span> -->
                  <span class="row-right">{{getKey(accountInfo.swift)}}</span>
                </div>
                <div class="info-row">
                  <span class="row-left">{{accountInfo.bankAddressTitle ? $t('bankInfo.'+accountInfo.bankAddressTitle) : ''}}</span>
                  <!-- <span class="row-left">{{getKey(accountInfo.bankAddressTitle)}}</span> -->
                  <span class="row-right">{{accountInfo.bankAddress ? $t('bankInfo.'+accountInfo.bankAddress) : ''}}</span>
                  <!-- <span class="row-right">{{getKey(accountInfo.bankAddress)}}</span> -->
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    step: Object,
    accountInfo: Object,
    currency: String
  },
  computed: {
    acckey: function () {
      if (this.currency == 'HKD') {
        return 'accHK'
      } else if (this.currency == 'USD') {
        return 'accUS'
      } else if (this.currency == 'CNY') {
        return 'accCN'
      }
    },
    wrap: function () {
      return window.screen.width <= 660
    }
  },
  data () {
    return {
      title: '3445',
      activeNames: [0]
    }
  },
  methods: {
    getKey (key) {
      let item = this.$t('bankInfo')
      return item[key] ? item[key] : key
    }
  }
}
</script>
<style lang='scss'>
.page-eddid-bank-account .el-card__body .title-wrap-right {
  max-width: 220px;
}
.el-collapse-item__header {
  line-height: 0;
}
.page-eddid-bank-account {
  border-radius: 10px;
  margin-bottom: 15px;
  .FPS-code{
    img{
      vertical-align: middle;
    }
    span{
      vertical-align: middle;
      line-height: 30px;
      height: 60px;
      display: inline-block;
      font-size: 16px;
      font-family: Muli-Bold;
      padding-left: 12px;
      color: #666;
    }
  }
  .el-collapse-item__wrap {
    border-bottom: none !important;
  }
  .el-card {
    border-radius: 10px;
  }
  .bank-card {
    margin-top: 1.5rem;
  }
  .el-card__body {
    position: relative;
    padding: 30px 0;
    // padding-left: 10px;
    .img-div {
      position: absolute;
      top: 50%;
      left: 0;
      width: 88px;
      transform: translateY(-50%);
      border-radius: 50% !important;
      img {
        margin: 0 auto;
        width: 3rem !important;
        vertical-align: middle;
      }
    }
    .wrap-div {
      padding-left: 10px;
      padding-right: 10px;
    }
    .el-collapse {
      border: none !important;
    }
    .el-collapse-item__header {
      border: none !important;
    }
    .fx {
      display: flex;
    }
    .column {
      flex-direction: column;
    }
    .bank-logo {
      display: inline-block;
      width: 50px;
      height: 50px;
    }
    .bank-name {
      color: rgba(102, 102, 102, 1);
      font-size: 16px;
      text-align: left;
      font-family: Muli-Bold;
      margin-left: 12px;
      line-height: 50px;
    }
    .bank-sub-title {
      min-width: 70px;
      color: rgba(102, 102, 102, 1);
      text-align: left;
      font-family: Muli-Bold;
      font-size: 16px;
    }
    .bank-number {
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
    }
    .mt-6 {
      margin-top: 6px;
    }
    .m-20p {
      margin-top: -20px;
    }
    // .title-wrap-left,.title-wrap-right{
    //   display: inline-block;
    //   height: 30%;
    // }
    // .title-wrap-left{
    //   vertical-align: middle;
    //   width: 50px;
    //   height: 50px;
    // }
    // .title-wrap-right{
    //   vertical-align: top;
    //   margin-left: 10px;
    //   line-height: 20px;
    // }
    // .first-title,.sub-title{
    //  height: 25px;
    // }
    // .first-title{
    //   color: rgba(102, 102, 102, 1);
    //   font-size: 16px;
    //   text-align: left;
    //   font-family: Muli-Bold;
    // }
    // .sub-title{
    //   color: rgba(36, 40, 45, 1);
    //   font-size: 16px;
    //   text-align: left;
    //   font-family: PingFangSC-Semibold;
    // }
    // .bank-icon{
    //   width: 50px;
    // }
    .detail-info {
      display: table;
      margin-top: 10px;
    }
    .info-row {
      display: table-row;
    }
    .info-row span {
      display: table-cell;
      padding-top: 10px;
    }
    .row-left {
      width: 100px;
      height: 14px;
      line-height: 14px;
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      text-align: left;
      font-family: Muli-Regular;
    }
    .row-right {
      width: 400px;
      height: 14px;
      line-height: 20px;
      color: rgba(36, 40, 45, 1);
      font-size: 14px;
      text-align: left;
      font-family: Muli-Regular;
    }
  }
}
@media only screen and (max-width: 660px) {
  .page-eddid-bank-account .el-card__body .img-div img {
    width: 3rem !important;
  }
  .el-collapse-item__header {
    line-height: 25px !important;
  }
  .bank-number {
    font-size: 12px !important;
  }
  .bank-sub-title {
    font-size: 14px !important;
  }
  .m-bank-logo {
    width: 40px!important;
    height: 40px!important;
  }
  .m-bank-name{
    font-size: 12px!important;
  }
  .m-row-left{
    width: 35% !important;
  }
}

@media only screen and (min-width: 660px) {
  .first-title,
  .sub-title {
    min-width: 400px;
  }
  .bank-sub-title {
    font-size: 14px !important;
  }
}
@media (max-width: 768px) {
  .el-collapse-item__header {
    line-height: 25px !important;
  }
  .bank-sub-title {
    font-size: 14px !important;
  }
  // .fx {
  //   display: flex;
  // }
  // .column {
  //   flex-direction: column;
  // }
}
</style>
